import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';
import { TOKEN_KEY } from '@common';

export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const toast = inject(ToastService);
  const router = inject(Router);
  const accessToken = localStorage.getItem(TOKEN_KEY.ACCESS_TOKEN_KEY);
  const refreshToken = localStorage.getItem(TOKEN_KEY.REFRESH_TOKEN_KEY);

  if (accessToken && refreshToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
        'x-refresh-token': refreshToken,
      },
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        localStorage.removeItem(TOKEN_KEY.ACCESS_TOKEN_KEY);
        localStorage.removeItem(TOKEN_KEY.REFRESH_TOKEN_KEY);
      }

      if (error.status === 498) {
        localStorage.removeItem(TOKEN_KEY.ACCESS_TOKEN_KEY);
        localStorage.removeItem(TOKEN_KEY.REFRESH_TOKEN_KEY);
        router.navigateByUrl('/home', { replaceUrl: true });
      }
      if (error.error.message) {
        toast.error(error.error.message);
      }
      return Promise.reject(error);
    }),
  );
};
